import React from 'react';
import { Box, Container, Typography, Card, CardContent, CardMedia, Button, Chip } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import { Link } from 'react-router-dom';
import StravaActivities from './StravaActivities';

const favoriteEvents = [
    {
        id: 1,
        title: 'Football Match - Liga 1',
        description: 'Alianza Lima vs Universitario de Deportes - The Peruvian football classic',
        date: 'December 15, 2024',
        time: '20:00',
        location: 'Estadio Nacional, Lima',
        city: 'Lima',
        image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400&h=250&fit=crop',
        sport: 'Football',
        price: '50-150 PEN',
        category: 'Match',
        icon: <SportsSoccerIcon />,
    },
    {
        id: 2,
        title: 'Basketball Championship',
        description: 'National basketball championship final',
        date: 'December 20, 2024',
        time: '20:00',
        location: 'Coliseo Eduardo Dibós, Lima',
        city: 'Lima',
        image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=250&fit=crop',
        sport: 'Basketball',
        price: '30-80 PEN',
        category: 'Final',
        icon: <SportsBasketballIcon />,
    },
];

const getSportColor = (sport) => {
    const colors = {
        'Football': '#FF6B6B',
        'Basketball': '#FF6B35',
    };
    return colors[sport] || '#666';
};

const UserList = () => {
    return (
        <Box sx={{ py: 4 }}>
            <Container maxWidth="md">
                <Typography variant="h4" fontWeight={700} gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
                    Your favorite events
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {favoriteEvents.map(ev => (
                        <Card
                            key={ev.id}
                            component={Link}
                            to={`/event/${ev.id}`}
                            sx={{
                                background: 'white',
                                borderRadius: 4,
                                boxShadow: '0 4px 24px rgba(255,107,107,0.10)',
                                p: 0,
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                overflow: 'hidden',
                                minHeight: { xs: 240, md: 260 },
                                height: { md: 260 },
                                alignItems: 'stretch',
                                mb: 4,
                                textDecoration: 'none',
                                transition: 'box-shadow 0.2s, transform 0.2s',
                                cursor: 'pointer',
                                '&:hover': {
                                    boxShadow: '0 8px 32px rgba(255,107,107,0.18)',
                                    transform: 'translateY(-2px) scale(1.01)',
                                },
                            }}
                        >
                            {/* Contenu à gauche */}
                            <Box sx={{ flex: 1, p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', minHeight: { xs: 160, md: 260 }, textAlign: 'left' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                    <Typography variant="h6" fontWeight={700} sx={{ mb: 0 }}>{ev.title}</Typography>
                                    <Chip
                                        label={ev.sport}
                                        sx={{
                                            background: getSportColor(ev.sport),
                                            color: 'white',
                                            fontWeight: 700,
                                            fontSize: 14,
                                            borderRadius: 999,
                                            px: 2,
                                            height: 28,
                                            ml: 1
                                        }}
                                    />
                                </Box>
                                <Typography color="text.secondary" sx={{ mb: 0.5 }}>{ev.date} at {ev.time}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Location: <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ev.location)}`} target="_blank" rel="noopener noreferrer" style={{ color: '#FF6B6B', textDecoration: 'underline', fontWeight: 700 }} onClick={e => e.stopPropagation()}>{ev.location}</a>
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    City: <span style={{ color: '#FF6B6B' }}>{ev.city}</span>
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Category: <span style={{ color: '#FF6B6B' }}>{ev.category}</span>
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Price: <span style={{ color: '#FF6B6B' }}>{ev.price}</span>
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    {ev.description}
                                </Typography>
                                <Box sx={{ flexGrow: 1 }} />
                            </Box>
                            {/* Image à droite, responsive */}
                            <Box sx={{ width: { xs: '100%', md: 340 }, height: { xs: 240, md: '100%' }, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end', p: 0, m: 0 }}>
                                <Box component="img" src={ev.image} alt={ev.sport} sx={{ width: '100%', height: '100%', objectFit: 'cover', borderTopRightRadius: { xs: 0, md: 16 }, borderBottomRightRadius: { xs: 0, md: 16 }, borderBottomLeftRadius: { xs: 16, md: 0 }, borderTopLeftRadius: { xs: 16, md: 0 }, display: 'block', transition: 'border-radius 0.2s' }} />
                            </Box>
                        </Card>
                    ))}
                </Box>
            </Container>
            {/* Strava activities at the bottom of the user list page */}
            <StravaActivities />
        </Box>
    );
};

export default UserList; 